
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404kaYXqEsyJF3WYRWfz1t214hLar2w9kaAQ5q4OZ6OTKQMeta } from "/notarias_webs_nuxt/pages/404.vue?macro=true";
import { default as Blog8wczb2792r_b_45Y5k_455KOcSBUJqEfvllKthS5T2o2Jr4Meta } from "/notarias_webs_nuxt/pages/Blog.vue?macro=true";
import { default as error_45_455Z80KOmNN3R_45n7bh0nXEvrp8cstm87JFbdJ5M75OwMeta } from "/notarias_webs_nuxt/pages/error.vue?macro=true";
import { default as index2_45NBETEQynWXt4CCFm_45VkgCTn_XGXA2Dui_45_WRqUGAYMeta } from "/notarias_webs_nuxt/pages/index.vue?macro=true";
import { default as EquipoYxP6NcYsAuLq0T3L_CTkXQOQL_45AjClsVH1gxEveYlNwMeta } from "/notarias_webs_nuxt/pages/Equipo.vue?macro=true";
import { default as GalleryOP28I4sgfv8lN9FlZE8MkK9oi1uLV4Ry0aRti9su3LAMeta } from "/notarias_webs_nuxt/pages/Gallery.vue?macro=true";
import { default as ContactomElnhZ781ehumxBeyF9sgBLyqiSnnmO1kVVZ6EEBBUEMeta } from "/notarias_webs_nuxt/pages/Contacto.vue?macro=true";
import { default as NotarioszVWM6wLfdEpRn6_84h63gvUYVIbZlp2tQwRYBDkTJwIMeta } from "/notarias_webs_nuxt/pages/Notarios.vue?macro=true";
import { default as _91id_93tDAppjd_45JVXi_3iFw2v_45WdCNf3NvJY8ASRt1bgVxL_YMeta } from "/notarias_webs_nuxt/pages/blog/[id].vue?macro=true";
import { default as ServiciosmYDK9u5HYXnCvdxBfPdmhZ1YrzTEwExQqIltd7s3310Meta } from "/notarias_webs_nuxt/pages/Servicios.vue?macro=true";
import { default as AvisoLegalJZGWwtZoClYaL5YAomVDIwuU1pDLbad8OefVpjo_45QZoMeta } from "/notarias_webs_nuxt/pages/AvisoLegal.vue?macro=true";
import { default as Accesibilidadix7n_TIregQX4sCJBug03mszn9fXaMkVsXl8JU8pglMMeta } from "/notarias_webs_nuxt/pages/Accesibilidad.vue?macro=true";
import { default as _91id_93Y3Z6JVRRiEbVab_45_9c6o_ATVBk_45qWRSMvtswzKGWp_45UMeta } from "/notarias_webs_nuxt/pages/servicios/[id].vue?macro=true";
import { default as PoliticaCookiescLyQbcoDHs5tG52YoyS135zjeOxcLbObz1I3TAMkH5IMeta } from "/notarias_webs_nuxt/pages/PoliticaCookies.vue?macro=true";
import { default as ProteccionDatosxFUJfpPQZcOLT6_45KgWa0LqeIIvaFWtQGQH_4548DKt8_sMeta } from "/notarias_webs_nuxt/pages/ProteccionDatos.vue?macro=true";
import { default as BlogDetails3eRkt5KAO3uUckEapcAT37n_EudvQA9tyYwtKefmJ9wMeta } from "/notarias_webs_nuxt/pages/blog/BlogDetails.vue?macro=true";
import { default as Servicefw8CfuQ7d7jqKymGfO1rTG_XjP95H_45BkIG4_45woxn8KUMeta } from "/notarias_webs_nuxt/pages/servicios/Service.vue?macro=true";
import { default as UnderConstructionumfys2zwFmgubFqfaQgK_q2Lj8VqJV_MgDjuJ9EzCg8Meta } from "/notarias_webs_nuxt/pages/UnderConstruction.vue?macro=true";
import { default as ServiceDetailsysEzMZTCXwys6WDQ_0SznDgaefr_mK0nx5QE70089lQMeta } from "/notarias_webs_nuxt/pages/servicios/ServiceDetails.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/notarias_webs_nuxt/pages/404.vue")
  },
  {
    name: "Blog",
    path: "/Blog",
    component: () => import("/notarias_webs_nuxt/pages/Blog.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/notarias_webs_nuxt/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/notarias_webs_nuxt/pages/index.vue")
  },
  {
    name: "Equipo",
    path: "/Equipo",
    component: () => import("/notarias_webs_nuxt/pages/Equipo.vue")
  },
  {
    name: "Gallery",
    path: "/Gallery",
    component: () => import("/notarias_webs_nuxt/pages/Gallery.vue")
  },
  {
    name: "Contacto",
    path: "/Contacto",
    component: () => import("/notarias_webs_nuxt/pages/Contacto.vue")
  },
  {
    name: "Notarios",
    path: "/Notarios",
    component: () => import("/notarias_webs_nuxt/pages/Notarios.vue")
  },
  {
    name: "blog-id",
    path: "/blog/:id()",
    component: () => import("/notarias_webs_nuxt/pages/blog/[id].vue")
  },
  {
    name: "Servicios",
    path: "/Servicios",
    component: () => import("/notarias_webs_nuxt/pages/Servicios.vue")
  },
  {
    name: "AvisoLegal",
    path: "/AvisoLegal",
    component: () => import("/notarias_webs_nuxt/pages/AvisoLegal.vue")
  },
  {
    name: "Accesibilidad",
    path: "/Accesibilidad",
    component: () => import("/notarias_webs_nuxt/pages/Accesibilidad.vue")
  },
  {
    name: "servicios-id",
    path: "/servicios/:id()",
    component: () => import("/notarias_webs_nuxt/pages/servicios/[id].vue")
  },
  {
    name: "PoliticaCookies",
    path: "/PoliticaCookies",
    component: () => import("/notarias_webs_nuxt/pages/PoliticaCookies.vue")
  },
  {
    name: "ProteccionDatos",
    path: "/ProteccionDatos",
    component: () => import("/notarias_webs_nuxt/pages/ProteccionDatos.vue")
  },
  {
    name: "blog-BlogDetails",
    path: "/blog/BlogDetails",
    component: () => import("/notarias_webs_nuxt/pages/blog/BlogDetails.vue")
  },
  {
    name: "servicios-Service",
    path: "/servicios/Service",
    component: () => import("/notarias_webs_nuxt/pages/servicios/Service.vue")
  },
  {
    name: "UnderConstruction",
    path: "/UnderConstruction",
    meta: UnderConstructionumfys2zwFmgubFqfaQgK_q2Lj8VqJV_MgDjuJ9EzCg8Meta || {},
    component: () => import("/notarias_webs_nuxt/pages/UnderConstruction.vue")
  },
  {
    name: "servicios-ServiceDetails",
    path: "/servicios/ServiceDetails",
    component: () => import("/notarias_webs_nuxt/pages/servicios/ServiceDetails.vue")
  }
]